export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9051.c501e160.jpg";